import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-md-7 mx-auto bg-white rounded-3 shadow-sm p-5 border border-light" }
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col-md-6 mx-auto header" }
const _hoisted_5 = { class: "answers" }
const _hoisted_6 = ["name", "id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = {
  key: 2,
  class: "row"
}
const _hoisted_11 = { class: "col-xl-11 mx-auto header" }
const _hoisted_12 = { class: "mx-auto col-md-9 mb-5 lead" }
const _hoisted_13 = { class: "table table-providers mb-0" }
const _hoisted_14 = { class: "align-middle" }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_guaranteed_income_modeller = _resolveComponent("guaranteed-income-modeller")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showIntro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-center" }, [
              _createElementVNode("i", { class: "bi bi-shield-check display-2 mb-5" })
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "skin-page-heading text-center" }, "Guaranteed Income", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "lead mt-4" }, " Buying some lifetime guaranteed income when you retire, or if you are in retirement can help in many ways. It will reduce the risk of not achieving what you want in retirement and will be payable no matter how long you live. This ensures you have the certainty of a guaranteed stream of monthly income. ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, " Some forms of lifetime guaranteed income now have surrender values in the first few years, in case your health or financial needs change dramatically. For all guaranteed income products you can usually get better rates if you are willing to answer some questions regarding your health and lifestyle. ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", null, " Answer one question and we can see which form of guaranteed income seems best for you. ", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mt-3",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onStartClick && _ctx.onStartClick(...args)))
              }, " Start ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showQuestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "skin-page-heading" }, "Guaranteed Income", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "question text-start mt-5" }, " Which option below best describes how you want to add some guaranteed income to your plan? ", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (answer, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "form-check shadow-sm d-flex align-self-center"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input d-flex align-self-center",
                    type: "radio",
                    name: `flexRadioDefault${_ctx.questionId}`,
                    id: `flexRadioDefault${_ctx.questionId}${i}`,
                    value: i,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.questionResponses[_ctx.questionId]) = $event))
                  }, null, 8, _hoisted_6), [
                    [_vModelRadio, _ctx.questionResponses[_ctx.questionId]]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `flexRadioDefault${_ctx.questionId}${i}`
                  }, _toDisplayString(answer), 9, _hoisted_7)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onContinueClick && _ctx.onContinueClick(...args)))
              }, " Continue "),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-outline-dark",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBackClick($event)))
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                    _createTextVNode(" Back ")
                  ]))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showOutcome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "skin-page-heading mb-5" }, " Want to add some Guaranteed Income to your plans? ", -1)),
            (_ctx.outcome == _ctx.GuaranteedIncomeOutcome.RetirementLine)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.retirementLineHeaderText), 1),
                  _createVNode(_component_sub_section, {
                    title: "Partners",
                    showHelp: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_13, [
                        _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Provider"),
                            _createElementVNode("th", null, "Best suited to?"),
                            _createElementVNode("th")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("td", { class: "align-middle" }, [
                              _createElementVNode("img", {
                                src: "/Content/images/Providers/logo-retirementline.png",
                                class: "img-fluid",
                                alt: "Retirement Line"
                              })
                            ], -1)),
                            _cache[15] || (_cache[15] = _createElementVNode("td", { class: "text-start align-middle" }, " Retirement Line is completely independent and as the largest annuity broker in the UK will search the whole market for you to find the best priced annuity specific to your needs and circumstances. ", -1)),
                            _createElementVNode("td", _hoisted_14, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-warning text-nowrap w-100",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.visitRetirementLineClicked && _ctx.visitRetirementLineClicked(...args)))
                              }, " Visit Retirement Line ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_ctx.outcome == _ctx.GuaranteedIncomeOutcome.JustModelling)
                ? (_openBlock(), _createBlock(_component_guaranteed_income_modeller, { key: 1 }))
                : _createCommentVNode("", true),
            (_ctx.showBackButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, [
                    _createElementVNode("a", {
                      href: "",
                      class: "btn btn-outline-dark",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onBackClick($event)))
                    }, _cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                      _createTextVNode(" Back ")
                    ]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}